import React, { useEffect, useState } from "react";
import useNetworkServices from "../../Networking/baseAPIManager";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../Common/Dropdown";
import DashbordCard from "../Common/Cards/DashbordCard";
import SubHeaderMenu from "../Sidebar/SubHeaderMenu";
import { Table } from "../Common/Table/Table";
import Button from "../Common/Button";
import industryicon from "../../assets/images/dashboardImg/Industryicon.svg";
import { MdOutlineFilterAlt } from "react-icons/md";
import { RiFilter2Line } from "react-icons/ri";
import Modal from "../Common/Modal ";
import CashFuseCard from "../Common/Cards/CahsFuseCard";
import CardBannerImage from "../../assets/images/Offers/CardBannerImage.png";
import CardBannerImage1 from "../../assets/images/Offers/CardBannerImage1.png";
import CardBannerImage2 from "../../assets/images/Offers/CardBannerImage2.png";
import CardBanner from "../Common/Cards/CardBanner";
import Loader from "../Common/Loader";
import { Toastify } from "../Common/Toastify";

function BannerOfferManagement() {
  const location = useLocation();
  const [offerListData, setOfferListData] = useState([]);
  const [cardCount, setCardCount] = useState([]);
  const [visibleRows, setVisibleRows] = useState(10);
  const [filterData, setFilterData] = useState([]);
  const [offerData, setOfferData] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [randomImage, setRandomImage] = useState(CardBannerImage);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("info");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const { bannerOfferList, bannerCardStatus } = useNetworkServices();
  const ImageURL = process.env.REACT_APP_BASE_URL_IMG || "";
  const getRandomImage = () => {
    const images = [CardBannerImage, CardBannerImage1, CardBannerImage2];
    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  };

  const columns = [
    { header: "Offer ID", accessor: "_id" },
    {
      header: "Merchant Name",
      accessor: "firstName",
      customTxt: (data) => {
        let fullName = `${
          data?.merchant[0]?.firstName == undefined
            ? "N/A"
            : data?.merchant[0]?.firstName
        } ${
          data?.merchant[0]?.lastName == undefined
            ? ""
            : data?.merchant[0]?.lastName
        }`;
        return <span>{fullName}</span>;
      },
    },
    {
      header: "Shop Name",
      accessor: "",
      customTxt: (data) => {
        let shopName = data?.merchant[0]?.businessDetils?.shopName
          ? data?.merchant[0]?.businessDetils?.shopName
          : "N/A";
        return <span>{shopName}</span>;
      },
    },
    {
      header: "Industry",
      accessor: "",
      customTxt: (data) => {
        let industry = data?.categories[0]?.title
          ? data?.categories[0]?.title
          : "N/A";
        return <span>{industry}</span>;
      },
    },
    {
      header: "Status",
      accessor: "status",
      customTxt: (data) => {
        let color =
          data?.status === "Pending"
            ? "#F07403"
            : data?.status === "Accept"
            ? "#1F9254"
            : "#CD6200";

        let bgColor =
          data?.status === "Pending"
            ? "#FFF4E5"
            : data?.status === "Accept"
            ? "#E5F7ED"
            : "#FDF0E3";

        return (
          <span
            style={{
              color,
              backgroundColor: bgColor,
              borderRadius: "0.8rem",
              padding: "0.5rem",
              display: "inline-block",
              textAlign: "center",
              width: "100px",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {data.status}
          </span>
        );
      },
    },

    {
      header: "Action",
      accessor: "",
      customBtn: (data) => {
        return (
          <Button
            type="button"
            label="View Detail"
            className="text-[#025D89]"
            onClick={() => {
              setIsOpen(true);
              setOfferData(data);
              setRandomImage(getRandomImage());
            }}
          />
        );
      },
    },
  ];

  const card = [
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Offer Request",
      content: cardCount?.totalOfferCount || 0,
    },
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Pending Request",
      content: cardCount?.Pending || 0,
    },
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Accept Request",
      content: cardCount?.Accept || 0,
    },
    {
      icon: industryicon,
      iconContainer: "#CEE4EF ",
      title: "Reject Request",
      content: cardCount?.Reject || 0,
    },
  ];

  const option = [
    { value: "All", name: "All Request" },
    { value: "Accept", name: "Approved Request" },
    { value: "Pending", name: "Pending Request" },
    { value: "Reject", name: "Reject Request" },
  ];

  const bannerList = async () => {
    setLoading(true);
    try {
      const response = await bannerOfferList();
      setCardCount(response?.data?.data?.bannerStatusCounts);
      setOfferListData(response?.data?.data?.bannerList);
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    bannerList();
  }, []);

  useEffect(() => {
    const filteredData =
      filterStatus === "All" || !filterStatus
        ? offerListData
        : offerListData.filter((item) => item.status === filterStatus);
    setFilterData(filteredData);
  }, [filterStatus, offerListData]);

  const statusUpdate = (status) => {
    const data = {
      id: offerData._id,
      status: status,
    };
    bannerCardStatus(data)
      .then((response) => {
        console.log(response.data, "response");
        setType("success")
        setMessage(response?.data?.message||"Banner updated successfully");
        setShow(true)
        
      })
      .catch((error) => {
        setType("error")
        setMessage(error?.response?.data?.message||"Banner update failed");
        setShow(true)
        console.log(error?.response?.data?.message, "errorrrrrrr");
      })
      .finally(() => {
        setIsOpen(false);
        bannerList();
      });
  };
  return (
    <div id="main" className="p-4">
      <Toastify type={type} message={message} show={show} setShow={setShow}/>
      <h1 className="font-bold text-2xl text-slate-900 pb-5">
        <span>Merchant Management</span> /{" "}
        <span className="text-red-500">
          <SubHeaderMenu location={location} />
        </span>
      </h1>
      <div className="py-2">
        <DashbordCard card={card} iconClass="rounded-full" />
      </div>

      <div className="w-full flex justify-end items-center pe-5 py-5 ">
        <div className="w-42 h-auto flex justify-between items-center border-[1px] bg-[#025D89] rounded-lg py-1 px-2">
          <MdOutlineFilterAlt className="text-white " />
          <Dropdown
            option={option}
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            SelectClass="bg-[#025D89] text-white outline-none "
          />
        </div>
      </div>
      <div>
        <Table columns={columns} data={filterData} tableClass="h-[580px]" />
      </div>
      {offerData ? (
        <Modal
          Classes="w-1/2 md:w-1/2 xl:w-7/12  h-auto p-2"
          className=""
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title="Offer Card"
        >
          <CardBanner
            title={
              (offerData &&
                offerData?.merchant &&
                Array.isArray(offerData?.merchant) &&
                offerData?.merchant[0]?.businessDetils?.shopName) ||
              "Super Store Gupta"
            }
            tagline={(offerData && offerData?.offerTitle) || "Big Discount"}
            description={(offerData && offerData?.storeOffer) || "10%"}
            buttonText={"Shop Now"}
            backgroundImage={randomImage}
            bannerProducImage={`${ImageURL}/${offerData.image}`}
          />
          <div className="flex justify-center p-2 gap-4">
            <Button
              type="button"
              text="Reject"
              className="border-custom-red border hover:border-custom-red w-full xl:mt-0 lg:mt-0 hover:text-white text-custom-red font-bold py-2 px-5 rounded-lg hover:bg-custom-red transition duration-300"
              onClick={() => statusUpdate("Reject")}
            />
            <Button
              type="button"
              text="Approved"
              className="border-custom-red border hover:border-custom-red w-full xl:mt-0 lg:mt-0 hover:text-custom-red text-white  font-bold py-2 px-4 rounded-lg hover:bg-white bg-custom-red transition duration-300"
              onClick={() => statusUpdate("Accept")}
            />
          </div>
        </Modal>
      ) : (
        " "
      )}
      {loading && <Loader />}
    </div>
  );
}

export default BannerOfferManagement;
